import { LongPollingSvc, useAuthedRequestFn } from '@my/util'
import { useEffect } from 'react'
import type { QueryClient } from '@tanstack/react-query'

export const useMiscProviderFn = (queryClient: QueryClient) => {
  const authedRequestFn = useAuthedRequestFn();

  useEffect(() => {
    LongPollingSvc.registerHandler('financial-review', async () => {
      const now = Date.now()
      let intervalId: ReturnType<typeof window.setInterval>;
      let clearThisInterval: () => void;
      const intervalPromise = new Promise(resolve => {
        intervalId = setInterval(async () => {
          let res;
          try {
            res = await authedRequestFn('/financial-review/poll', { method: 'GET', params: {timestamp:now} });
          } catch (error) {
            console.error(error);
          }
          if (res?.isUpdateReady) {
            resolve(clearInterval(intervalId));
          }
          //console.log('um', new Date().toLocaleString());
        }, 15000);
        clearThisInterval = () => resolve(clearInterval(intervalId));
      });
      const timeoutPromise = new Promise(resolve => setTimeout(() => {
        resolve(clearThisInterval());
      }, 150000));
      await Promise.race([intervalPromise, timeoutPromise]);
      await queryClient.refetchQueries({ queryKey: ['financial-review']});
    });
    //console.log(LongPollingSvc);
  }, []);
}